// extracted by mini-css-extract-plugin
export default {"cardContainer":"Card_cardContainer__QXsP2","process":"Card_process__xh+co","finished":"Card_finished__5rbDx","paused":"Card_paused__vHf0f","deceased":"Card_deceased__uVup+"};